// modules/website/components/RichTextComponent.tsx

import React from 'react';
import { RichTextData } from '@/types';

interface Props {
  data: RichTextData;
  settings: any;
}

export const RichTextComponent: React.FC<Props> = ({ data, settings }) => {
  return (
    <div 
      className="py-12 px-6"
      style={{
        backgroundColor: settings.backgroundColor || '#ffffff',
        color: settings.textColor || '#000000',
      }}
    >
      <div 
        className={`mx-auto prose prose-lg ${
          data.alignment === 'center' ? 'text-center' : 
          data.alignment === 'right' ? 'text-right' : 
          'text-left'
        }`}
        style={{ maxWidth: data.maxWidth ||'800px' }}
      >
        <div dangerouslySetInnerHTML={{ __html: data.content }} />
      </div>
    </div>
  );
};
